"use strict";
//: getManagement - функция получения с сервера данных для начального запуска сайта, вернет обьект типа 
//: { 
//:     _id: object, (id - обьекта)
//:     isShowBaner: boolean, (true/false для определения надо ли показывать рекламный банер)
//:     cursUsd: string, (вернет курс доллара установленный админом)
//:     __v: 0
//: }
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const interface_1 = require("../helps/interface");
const processRespons_1 = __importDefault(require("../helps/processRespons"));
const getManagement = async () => {
    try {
        // console.log('%c start fnc getManagement ', 'background: blue;color: white;');
        const url = interface_1.Link.Management;
        const resManagement = await fetch(url)
            .then(res => res?.json())
            .then((res) => {
            if ('error' in res)
                return (0, processRespons_1.default)(res);
            //console.log('%c Response >>> ', 'color: red; background: white;', res);
            return res;
        })
            .catch(error => console.log(error));
        return resManagement;
    }
    catch (error) {
        console.log('Error in Function getManagement >>> ', error);
    }
};
exports.default = getManagement;
